<template>
    <div class="g-bg-gray g-h100">
        <van-tabs v-model="active">
            <van-tab v-for="i in 4" :title="tabTitles[i - 1]" :key="i">
                <div class="tab-content g-ofauto">
                  <activityList :active="active" />
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import activityList from './coms/activity-list.vue'

export default {
  name: 'MemberActivity',
  components: {
    activityList,
  },
  data () {
    return {
      pageTitle: '活动列表',
      active: 0,
      tabTitles: ['全部', '未开始', '进行中', '已结束']
    }
  },
  computed: {      
      memberUseInfo () {
          return this.$store.state.memberUserInfos || {};
      },
  },
  created () {
    if (!this.memberUseInfo.id) {
        this.$toast('请选择学员');
        this.$router.push('/member-stu-chooser');
    }
  },
}
</script>

<style lang="scss" scoped>
.g-h100 {
    height: 100%;
}
.g-ofauto {
    overflow: auto;
}
.g-bg-gray {
    background-color: #f7f8f9;
}
.tab-content {
    height: calc(100vh - 44px);
}
</style>
